/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

// import {
//     IAgentPlugin,
//     IPluginMethodMap,
//   } from '@vlinder-web/plugin-agent-service-react';
// import { holdersListConfig } from '../../config/holderList.config';
//   export interface IHoldersListPluginMethods extends IPluginMethodMap {
//     getHoldersListSync(args?: any): any;
//   }

//   export class HoldersListPlugin implements IAgentPlugin {
//     readonly methods: IHoldersListPluginMethods;

//     constructor() {
//       this.methods = {
//         getHoldersListSync: this.getHoldersListSync.bind(this),
//       };
//     }

//     async getHoldersListSync(args?: any) {
//       await new Promise((r) => setTimeout(r, 2000));
//       return {
//         HoldersList:holdersListConfig
//       };
//     }
//   }

/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { holdersListConfig } from '../../config/holderList.config';
import { GET_USER_LIST } from '@pages/HolderPage/api/graphql';

import { Graphql } from '@common/graphql';
import { apiConfig } from '@pages/HolderPage/config/api.config';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';

import { toHeaderCase } from 'js-convert-case';
import moment from 'moment';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IHoldersListPluginMethods extends IPluginMethodMap {
  getHoldersList(args: any): Promise<any>;
}

export class HoldersListPlugin implements IAgentPlugin {
  readonly methods: IHoldersListPluginMethods;

  constructor() {
    this.methods = {
      getHoldersList: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    return await this.getAppCardList(args);
  }

  private async getAppCardList(args: any) {
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .query(GET_USER_LIST, {
          input: {
            skip: args?.offset ?? 0,
            limit: args?.size ?? 10,
            where: [...args?.where],
            order: [
              {
                column: 'createdAt',
                direction: 'DESC',
              },
            ],
            relationFilter: {
              role: {
                where: [
                  {
                    column: 'name',
                    value: ['purchaser'],
                    op: 'Equal',
                  },
                ],
              },
            },
          },
        })
        .toPromise();
      if (res?.data) {
        console.log(`table data`, res);
        let _rowData = this.formatUserTable(res?.data?.getUserList?.data);
        console.log(`row data`, _rowData);
        return {
          ...holdersListConfig,
          ultUsers: _rowData,
          isEmpty: res?.data?.getUserList?.data?.length <= 0,
          // studentGroup: holderGroups,
          activePage: res?.data?.getUserList?.currentPage,
          pageSize: res?.data?.getUserList?.pageSize,
          totalCount: res?.data?.getUserList?.totalCount,
          totalPages: res?.data?.getUserList?.totalPages,
        };
      }
    } catch (err: any) {
      return {
        isEmpty: true,
      };
    }
  }
  private formatUserTable(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any) => {
        return {
          id: item?.vuid,
          status: this.getFormattedStatus(item?.accountStatus, item?.suspended),
          verified: item?.emailVerified,
          name: `${toHeaderCase(item?.firstName ?? '')} ${toHeaderCase(
            item?.lastName ?? ''
          )}`,
          email: item?.email,
          dateCreated: this.formatCreatedDate(item?.createdAt),
          kycStatus: this.getKycStatus(item?.kyc) ?? '-',
          image:
            item?.image ??
            `https://ui-avatars.com/api/?name=${item?.firstName}+${item?.lastName}&background=0D8ABC&color=fff`,
        };
      });

    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format('LLL');
    } else return '-';
  }

  private getKycStatus(data: any) {
    let _temp = Array.isArray(data) && data?.find((item) => item?.status);
    return _temp?.status;
  }

  private getFormattedStatus(status: string, suspended: boolean) {
    if (suspended) {
      return 'suspended';
    } else {
      switch (status) {
        case 'USER_ADDED':
          return 'created';
        case 'USER_INVITED':
          return 'invited';
        case 'USER_EMAIL_VERIFIED':
          return 'verified';
        case 'USER_VERIFIED':
          return 'verified';
        case 'USER_ACC_CREATED':
          return 'active';
        case 'WALLET_REGISTERED':
          return 'active';
        case 'SUSPENDED':
          return 'suspended';
        default:
          return '-';
      }
    }
  }
}
